<div style="height: calc(100% + 15px); min-height: 900px; min-width: 1200px" class="d-flex">
  <div style="background-color: var(--empty-background); position: relative" class="flex-fill py-4">
    <div class="mb-4" style="margin-left: 40px">
      @if (portal.name) {
        <div data-testid="cross-selling-title-selector" class="cross-selling__title mb-4">
          Enjoy the following features in {{ portal.name }}:
        </div>
      }
      @if (portal.features) {
        <ul class="pl-3">
          @for (item of portal.features; track item.addon; let i = $index) {
            <li class="cross-selling__feature" [attr.data-testid]="'cross-selling-feature-' + i">{{ item.feature }}</li>
          }
        </ul>
      }
      @if (portal.name) {
        <div data-testid="cross-selling-subtitle-selector" class="cross-selling__advertisement mt-4">
          Request a demo today and access to {{ portal.name }}
        </div>
      }
    </div>
    <div style="padding-left: 100px; padding-right: 60px">
      @if (portal.target) {
        <div [id]="portal.target"></div>
      }
    </div>
  </div>
  <div
    style="
      flex-basis: 840px;
      flex-grow: 0;
      flex-shrink: 0;
      background-color: var(--empty-background);
      position: relative;
    "
    class="h-100"
  >
    <div style="width: 720px" class="h-100 ml-auto udt__gradient-bg"></div>
    <div style="width: 840px; position: absolute; left: 0; top: 150px; overflow: hidden">
      @if (portal.addonName) {
        <img
          data-testid="cross-selling-img-selector"
          width="1200px"
          src="../../../../../assets/images/{{ portal.addonName }}-preview.png"
          [alt]="portal.name + ' Preview' || 'Preview'"
        />
      }
    </div>
  </div>
</div>
